/* The opening, as on the live page (his note: "use the intro from the other previous page where it was more structured
   and organized"). The hand and the pendant are drawn by the live page's own renderer (hand-gl.js is theme v3.3.4
   assets/onevine-rosary-gl.js, unchanged), framed as the live page frames them: the title beside the hand, then the
   three lines of the Hail Mary with the view in on the pinched bead. rail.js says where the scroll is
   (RosaryOpening.at); after the third line the bead comes to the middle of the screen and opens like a window onto
   the rosary below (the rail canvas, under this layer). */
(function () {
  'use strict';

  var FAR = 99, NIGHT = [0.5, 0.2, 0.06];
  var DIVE_AT = 4, DIVE = 1.6;           // screens into the opening: the dive starts after the third line, and lasts this long
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(a, b, v) { var t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function mix(a, b, t) { return a + (b - a) * t; }
  function ease(t) { t = clamp(t, 0, 1); return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  var layer = document.getElementById('hand'), canvas = document.getElementById('hand-canvas'), ring = document.getElementById('hand-ring');
  var stops = Array.prototype.slice.call(document.querySelectorAll('[data-op]'));
  var veils = Array.prototype.slice.call(document.querySelectorAll('[data-op-veil]'));
  var GL = window.OneVineRosaryGL;
  var renderer = GL && canvas ? GL.createRenderer(canvas) : null;
  var api = { at: function () {}, place: 0 };
  window.RosaryOpening = api;
  if (!renderer) { if (layer) layer.hidden = true; return; }
  var world = GL.buildWorld();
  renderer.setScene(world.hand, world.rest);
  var r = world.r, pinch = world.pinch;

  // ---- the stops, measured once per resize (the live page's numbers, onevine-rosary.js measure()) ----------------
  var shots = [], W = 0, H = 0, drawn = false, last = 0;
  function blank() {
    return { fx: pinch.x, fy: pinch.y, sx: 0, sy: 0, zoom: 1, focusX: pinch.x, focusY: pinch.y, soft0: FAR, soft1: FAR + 1, gone0: FAR, gone1: FAR + 1,
      lit: 0, handAlpha: 1, tile: 0, glow: 0 };
  }
  // On a phone the view of the bead sits between a line and its ledger.
  function band(stop) {
    var upper = stop.querySelector('.op__line'), lower = stop.querySelector('.op__ledger');
    var box = { top: H * 0.3, bottom: H * 0.7 };
    if (upper) box.top = upper.getBoundingClientRect().bottom + 16;
    if (lower) box.bottom = lower.getBoundingClientRect().top - 16;
    if (box.bottom - box.top < 120) box = { top: H * 0.3, bottom: H * 0.7 };
    return box;
  }
  function measure() {
    W = window.innerWidth; H = window.innerHeight;
    var ratio = Math.max(1, Math.min(Math.min(window.devicePixelRatio || 1, 2), Math.sqrt(2400000 / (W * H))));
    renderer.resize(W, H, ratio);
    var wide = W >= 990, frameW = Math.min(W, H * 1.7778), frameL = (W - frameW) / 2;
    // the opening: where the live page's CSS puts the still picture of the hand
    var a = blank();
    a.zoom = wide ? Math.min(0.6 * frameW, 0.96 * H) : Math.min(1.08 * W, 0.7 * H);
    a.sx = wide ? frameL + 0.69 * frameW : 0.74 * W;
    a.sy = wide ? 0.43 * H : 0.555 * H;
    a.focusX = pinch.x + world.down.x * 0.2; a.focusY = pinch.y + world.down.y * 0.2;
    a.soft0 = 0.5; a.soft1 = 0.62; a.gone0 = 0.58; a.gone1 = 0.7; a.glow = 0.5;
    shots = [a];
    for (var k = 1; k <= 3; k++) {
      var s = blank(), gap = band(stops[k]);
      s.sx = wide ? frameL + frameW * 0.41 : W * 0.52;
      s.sy = wide ? H * 0.5 : (gap.top + gap.bottom) / 2;
      var radius = wide ? Math.min(128, H * 0.16) : clamp((gap.bottom - gap.top) * 0.3, 54, 86);
      s.zoom = radius / r * mix(0.78, 1, k / 3);
      s.soft0 = 0.05; s.soft1 = 0.13; s.gone0 = 0.17; s.gone1 = 0.3;
      s.lit = 0.04 + 0.96 * k / 3; s.tile = 1; s.glow = 1;
      shots.push(s);
    }
  }

  // ---- the view at a place between two stops (the live page's sceneAt, without the mystery windows) ---------------
  var frame = { x: 0, y: 0, zoom: 1, rot: 0, focusX: 0, focusY: 0, soft0: FAR, soft1: FAR + 1, gone0: FAR, gone1: FAR + 1,
    tintR: NIGHT[0], tintG: NIGHT[1], tintB: NIGHT[2], lit: 0, handBlur: 0, handLight: 1, handAlpha: 1, tile: 0, artSlot: 0, under: [], over: [] };
  var pinchGlow = { x: pinch.x, y: pinch.y, hw: 0, hh: 0, kind: 3, p: [0, 1, 0.62, 0.2] };
  function sceneAt(place) {
    var index = clamp(Math.floor(place), 0, shots.length - 2), part = clamp(place - index, 0, 1);
    var a = shots[index], b = shots[index + 1], e = part * part * (3 - 2 * part);
    var far = Math.hypot(b.fx - a.fx, b.fy - a.fy) * Math.sqrt(a.zoom * b.zoom);
    var dip = clamp(far / (W * 3), 0, 0.35) * Math.sin(Math.PI * e);
    var widen = 1;   // the live page sharpens the strand mid-move; here the beads round the pinch stay soft throughout (his note: "pick either in or out")
    var v = {
      zoom: Math.exp(mix(Math.log(a.zoom), Math.log(b.zoom), e)) * (1 - dip),
      sx: mix(a.sx, b.sx, e), sy: mix(a.sy, b.sy, e)
    };
    frame.focusX = mix(a.focusX, b.focusX, e); frame.focusY = mix(a.focusY, b.focusY, e);
    frame.soft0 = mix(a.soft0, b.soft0, e) * widen; frame.soft1 = mix(a.soft1, b.soft1, e) * widen;
    frame.gone0 = mix(a.gone0, b.gone0, e) * widen; frame.gone1 = mix(a.gone1, b.gone1, e) * widen;
    frame.lit = mix(a.lit, b.lit, e); frame.tile = mix(a.tile, b.tile, e); frame.handAlpha = 1;
    var glow = mix(a.glow, b.glow, e);
    frame.under.length = 0;
    if (glow > 0.01) { pinchGlow.hw = pinchGlow.hh = r * (4 + frame.lit * 3); pinchGlow.p[0] = 0.5 * glow; frame.under.push(pinchGlow); }
    return v;
  }

  // Each stop rests for half a screen of scrolling, then the view travels on to the next.
  function placeOf(p) { if (p >= 3) return 3; var k = Math.floor(p); return k + smooth(0.5, 1, p - k); }
  var hidden = false, maskOn = false;
  function write(el, key, value) { if (el && el['_' + key] !== value) { el['_' + key] = value; el.style[key] = value; } }
  function at(p) {
    last = p;
    var done = p >= DIVE_AT + DIVE;
    if (done !== hidden) {
      hidden = done;
      write(layer, 'visibility', done ? 'hidden' : 'visible'); write(ring, 'visibility', done ? 'hidden' : 'visible');
      stops.concat(veils).forEach(function (el) { write(el, 'opacity', '0'); write(el, 'visibility', 'hidden'); });
    }
    if (done || !W) return;
    var place = placeOf(p), td = clamp((p - DIVE_AT) / DIVE, 0, 1), dive = ease(smooth(0, 0.7, td));
    api.place = place;
    var v = sceneAt(place);
    // the dive: in towards the pinched bead, which comes to the middle of the screen
    var zoom = v.zoom * (1 + 2.2 * dive), sx = mix(v.sx, W / 2, dive), sy = mix(v.sy, H / 2, dive);
    frame.zoom = zoom; frame.rot = 0;
    frame.x = pinch.x - (sx - W / 2) / zoom; frame.y = pinch.y - (sy - H / 2) / zoom;
    if (drawn) renderer.draw(frame);
    // ... and opens: a round window, edged with light, growing until the rosary below fills the screen
    var rb = r * 1.025 * zoom, corner = Math.max(Math.hypot(sx, sy), Math.hypot(W - sx, sy), Math.hypot(sx, H - sy), Math.hypot(W - sx, H - sy));
    var hole = td > 0 ? mix(rb * 0.85 * smooth(0, 0.25, td), corner * 1.08, Math.pow(smooth(0.2, 0.72, td), 1.7)) : 0;
    if (hole > 0.5) {
      var m = 'radial-gradient(circle at ' + sx.toFixed(1) + 'px ' + sy.toFixed(1) + 'px, transparent ' + hole.toFixed(1) + 'px, #000 ' + (hole + Math.max(1.5, hole * 0.05)).toFixed(1) + 'px)';
      layer.style.webkitMaskImage = m; layer.style.maskImage = m; maskOn = true;
    } else if (maskOn) { layer.style.webkitMaskImage = ''; layer.style.maskImage = ''; maskOn = false; }
    write(layer, 'opacity', (1 - smooth(0.48, 0.72, td)).toFixed(3));
    var rim = smooth(0.02, 0.12, td) * (1 - smooth(0.4, 0.68, td));
    write(ring, 'opacity', rim.toFixed(3));
    if (rim > 0) ring.style.transform = 'translate3d(' + (sx - hole).toFixed(1) + 'px,' + (sy - hole).toFixed(1) + 'px,0)', ring.style.width = ring.style.height = (2 * hole).toFixed(1) + 'px';
    // the words: each stop's own, fading and drifting as the live page's do; the third line goes as the bead opens
    var most = 0;
    stops.forEach(function (el, k) {
      var on = (1 - smooth(0.14, 0.42, Math.abs(place - k))) * (k === 3 ? 1 - smooth(0, 0.25, td) : 1);
      if (k > 0) most = Math.max(most, on);
      write(el, 'opacity', on.toFixed(3)); write(el, 'visibility', on > 0.002 ? 'visible' : 'hidden');
      write(el, 'transform', 'translate3d(0,' + ((k - place) * 26).toFixed(1) + 'px,0)');
      el.setAttribute('aria-hidden', on > 0.5 ? 'false' : 'true');
    });
    veils.forEach(function (el) { write(el, 'opacity', most.toFixed(3)); write(el, 'visibility', most > 0.002 ? 'visible' : 'hidden'); });
  }
  api.at = at;
  api.measure = function () { measure(); at(last); };

  function load(src) { return new Promise(function (ok, no) { var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async'; im.onload = function () { ok(im); }; im.onerror = function () { no(new Error('Could not load ' + src)); }; im.src = src; }); }
  measure();
  var ASSETS = window.RosaryRailAssets || {};
  function src(name) { return ASSETS[name] || name; }
  api.ready = Promise.all([load(src('rosary-hand-2048.webp')), load(src('rosary-bead-mask.png'))]).then(function (pair) {
    renderer.setHand(pair[0]); renderer.setMask(pair[1]);
    drawn = true; at(last);
    layer.classList.add('is-drawn');
    load(src('rosary-hand-pinch.webp')).then(function (im) { renderer.setTile(im); at(last); }, function () {});
  }, function (error) { console.error(error); });
  window.addEventListener('resize', api.measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(api.measure);   // the phone's view of the bead depends on where the words fall
  var begin = document.querySelector('[data-begin]');
  if (begin) begin.addEventListener('click', function (event) {
    event.preventDefault();
    if (window.RosaryRoad && window.RosaryRoad.go) window.RosaryRoad.go(1);
  });
})();
